import { RootState } from "app/store";
import { createSelector } from "@reduxjs/toolkit";

export const selectReportsReducerLoading = (state: RootState) =>
  state.rootReducer.reportsReducer.loading;

export const selectAllReports = (state: RootState) =>
  state.rootReducer.reportsReducer.report;

export const selectAllResolvedAddress = (state: RootState) =>
  state.rootReducer.reportsReducer.resolvedAddresses;

export const selectResolvedAddressLoading = (state: RootState) =>
  state.rootReducer.reportsReducer.resolvedAddressLoading;

export const selectReportsFilterData = (state: RootState) =>
  state.rootReducer.reportsReducer.reportsFilterData;

export const selectReportsDateValues = (state: RootState) =>
  state.rootReducer.reportsReducer.reportsDateValues;

export const selectReportsHasExceededLimit = (state: RootState) =>
  state.rootReducer.reportsReducer.hasExceededLimit;

export const selectXarReport = (state: RootState) =>
  state.rootReducer.reportsReducer.xarReport;

export const selectXarReportLoading = (state: RootState) =>
  state.rootReducer.reportsReducer.xarReportLoading;

export const selectReportsState = createSelector(
  selectReportsReducerLoading,
  selectAllReports,
  selectAllResolvedAddress,
  selectResolvedAddressLoading,
  selectReportsFilterData,
  selectReportsDateValues,
  selectReportsHasExceededLimit,
  selectXarReport,
  selectXarReportLoading,
  (
    loading,
    report,
    resolvedAddresses,
    resolvedAddressLoading,
    reportsFilterData,
    reportsDateValues,
    reportsHasExceededLimit,
    xarReport,
    xarReportLoading
  ) => {
    return {
      loading,
      report,
      resolvedAddresses,
      resolvedAddressLoading,
      reportsFilterData,
      reportsDateValues,
      reportsHasExceededLimit,
      xarReport,
      xarReportLoading
    };
  }
);
